class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;

    // Native <details>/<summary> only opens/closes on click, with no
    // hover-intent bridge between a trigger and its panel — moving the
    // mouse from one top-level item toward the next relied entirely on
    // focus transfer, which is fragile and reads as the menu vanishing
    // mid-movement. This adds a conventional hover-intent pattern
    // (open immediately on enter, close after a short delay on leave)
    // on top of the existing click/focus behaviour, which remains the
    // fallback for touch and keyboard users.
    this.mouseNavigationEnabled = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (this.mouseNavigationEnabled) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  onMouseEnter() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    if (!this.mainDetailsToggle.open) this.mainDetailsToggle.open = true;
  }

  onMouseLeave() {
    // Short delay so ordinary mouse movement across the gap toward a
    // neighbouring nav item (or down into the panel itself, since both
    // live inside this same <header-menu>) doesn't collapse the menu.
    this.closeTimeout = setTimeout(() => {
      this.close();
      this.closeTimeout = null;
    }, 200);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
